import { Component } from "react";

// Catches a render crash in whatever it wraps (e.g. one malformed product
// record breaking a listing page) and shows a small recoverable message
// instead of leaving the rest of the app (or an infinite loading state)
// stuck. Added after a production incident where a single bad Mongo record
// on the Roof Tents listing left the page spinning indefinitely.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught an error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary-fallback"
          className="min-h-[50vh] flex flex-col items-center justify-center text-center px-6 py-20"
        >
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-[var(--text-tertiary)] mb-3">
            Something Went Wrong
          </p>
          <p className="text-white/80 max-w-md">
            This section couldn't load. Please refresh the page, or contact us if the problem continues.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
